module.exports = __webpack_public_path__ + "static/media/background-9.1139de2c.jpg";